import React from 'react';
import { Container } from 'react-bootstrap';
import './TermsOfService.css';

const TermsOfService = () => {
  const lastUpdated = '19.03.2026';

  return (
    <div className="terms-page">
      <Container fluid className="terms-container">
        <h1 className="terms-title">Terms Of Service</h1>
        <div className="terms-card">
          <section className="terms-section">
            <h2 className="terms-section-heading">
              <span className="terms-section-num">1.</span> Introduction
            </h2>
            <p className="terms-body">
              Welcome to our online store. By accessing or using this website, you agree to comply with and be bound by these Terms &amp; Conditions. Please read them carefully before placing any order.
            </p>
          </section>

          <section className="terms-section">
            <h2 className="terms-section-heading">
              <span className="terms-section-num">2.</span> Product Information
            </h2>
            <p className="terms-body">
              We strive to display accurate product colors, details, and descriptions. However, slight variations may occur due to screen settings, lighting, or fabric batches. These variations do not qualify as product defects.
            </p>
          </section>

          <section className="terms-section">
            <h2 className="terms-section-heading">
              <span className="terms-section-num">3.</span> Pricing &amp; Payment
            </h2>
            <p className="terms-body">
              All prices listed on the website are final and inclusive of applicable taxes unless stated otherwise. Payment must be completed at checkout using the available payment methods. Orders will be processed only after successful payment.
            </p>
          </section>

          <section className="terms-section">
            <h2 className="terms-section-heading">
              <span className="terms-section-num">4.</span> Order Confirmation
            </h2>
            <p className="terms-body">
              Once an order is placed, you will receive an order confirmation via email or SMS. We reserve the right to cancel or refuse any order due to stock issues, incorrect pricing, or suspicious activity. In such cases, any payment made will be refunded.
            </p>
          </section>

          <section className="terms-section">
            <h2 className="terms-section-heading">
              <span className="terms-section-num">5.</span> Shipping &amp; Delivery
            </h2>
            <p className="terms-body">
              Delivery timelines may vary based on location and external factors such as courier delays, weather conditions, or holiday seasons. Estimated delivery dates are provided for convenience and are not guaranteed.
            </p>
          </section>

          <section className="terms-section">
            <h2 className="terms-section-heading">
              <span className="terms-section-num">6.</span> Returns, Refunds &amp; Exchanges (Updated)
            </h2>
            <ul className="terms-list">
              <li>Refunds, returns, or exchanges are available only for damaged, defective, or incorrect items.</li>
              <li>Customers must report issues within 24 hours of delivery.</li>
              <li>Returned items must be unused, unwashed, and in original packaging.</li>
              <li>Return courier charges for customer-initiated returns must be borne by the customer.</li>
              <li>Exchanges are only applicable for damaged or incorrect items, not for size or preference changes.</li>
              <li>Approval of refunds or exchanges rests solely with the company after verifying the claim.</li>
            </ul>
          </section>

          <section className="terms-section">
            <h2 className="terms-section-heading">
              <span className="terms-section-num">7.</span> Cancellation Policy
            </h2>
            <p className="terms-body">
              Orders can only be cancelled before they are dispatched. Once shipped, cancellations cannot be accepted.
            </p>
          </section>

          <section className="terms-section">
            <h2 className="terms-section-heading">
              <span className="terms-section-num">8.</span> User Responsibilities
            </h2>
            <p className="terms-body">
              Users must provide accurate personal and delivery information. We are not responsible for delays or failed deliveries caused by incorrect details provided by the customer.
            </p>
          </section>

          <section className="terms-section">
            <h2 className="terms-section-heading">
              <span className="terms-section-num">9.</span> Intellectual Property
            </h2>
            <p className="terms-body">
              All content on this website—including images, logos, designs, product photos, and text—is the property of the brand. Unauthorized use, reproduction, or distribution is strictly prohibited.
            </p>
          </section>

          <section className="terms-section">
            <h2 className="terms-section-heading">
              <span className="terms-section-num">10.</span> Limitation of Liability
            </h2>
            <p className="terms-body">
              The company is not liable for any indirect, incidental, or consequential damages arising from the use or inability to use our website or products.
            </p>
          </section>

          <section className="terms-section">
            <h2 className="terms-section-heading">
              <span className="terms-section-num">11.</span> Privacy
            </h2>
            <p className="terms-body">
              Your personal information is handled as per our Privacy Policy. By using the site, you consent to the collection and use of your data in accordance with that policy.
            </p>
          </section>

          <section className="terms-section">
            <h2 className="terms-section-heading">
              <span className="terms-section-num">12.</span> Amendments
            </h2>
            <p className="terms-body">
              We reserve the right to update or modify these Terms &amp; Conditions at any time without prior notice. Continued use of the website constitutes acceptance of the updated terms.
            </p>
          </section>

          <section className="terms-section">
            <h2 className="terms-section-heading">
              <span className="terms-section-num">13.</span> Contact
            </h2>
            <p className="terms-body">
              If you have any questions regarding these Terms &amp; Conditions, please contact our customer support team.
            </p>
          </section>

          <p className="terms-last-updated">Last Updated on: {lastUpdated}</p>
        </div>
      </Container>
    </div>
  );
};

export default TermsOfService;
